import script from "./FormulasIngredientTrait.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasIngredientTrait.vue?vue&type=script&setup=true&lang=js"

import "./FormulasIngredientTrait.vue?vue&type=style&index=0&id=056b7f14&lang=scss"

const __exports__ = script;

export default __exports__